/**
 * Normalize coil shift samples from Firestore (array or map-like object with numeric keys).
 * Matches skimbuster-mobile `utility/coilShiftData.ts` so web viewers see the same curve when data exists.
 */
export function normalizeCoilShiftData(raw: unknown): unknown[] | null {
  if (raw == null) return null;
  if (Array.isArray(raw)) {
    return raw.length >= 2 ? raw : null;
  }
  if (typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    const keys = Object.keys(o)
      .filter((k) => /^\d+$/.test(k))
      .sort((a, b) => Number(a) - Number(b));
    if (keys.length >= 2) {
      return keys.map((k) => o[k]);
    }
  }
  return null;
}

/** Y value from a sample point (Firestore / export variants). */
export function coilShiftY(p: unknown): number {
  if (p == null || typeof p !== 'object') return 0;
  const o = p as Record<string, unknown>;
  if (typeof o.shift === 'number' && !Number.isNaN(o.shift)) return o.shift;
  const alt = o.coil_shift ?? o.coilShift;
  const n = typeof alt === 'number' ? alt : Number(alt);
  return Number.isFinite(n) ? n : 0;
}
